const ClientMyHealersIcon = ({ fillColor = '#000' }: { fillColor: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21" fill="none">
      <path
        d="M14.7956 15.8353C14.4537 14.8785 13.7004 14.033 12.6526 13.4299C11.6047 12.8269 10.3208 12.5 9 12.5C7.6792 12.5 6.3953 12.8269 5.34743 13.4299C4.29957 14.033 3.5463 14.8785 3.20445 15.8353"
        stroke={fillColor}
        strokeLinecap="round"
      />
      <circle cx="9" cy="6.5" r="3" stroke={fillColor} strokeLinecap="round" />
    </svg>
  );
};

export default ClientMyHealersIcon;
